/** Canonical Vistoera brand mark — reuses marketing `.mkt-brand-mark` styles. */

interface Props {
  className?: string
}

export default function VistoeraBrandMark({ className }: Props) {
  return <span className={className ? `mkt-brand-mark ${className}` : 'mkt-brand-mark'}>V</span>
}
